var _path, _g, _path2, _path3, _path4, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 16,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.957H17.1838V21.0566H2V13.957Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.592 15.457C6.813 15.457 3.5 15.814 3.5 17.519C3.5 18.871 5.55 19.557 9.592 19.557C13.634 19.557 15.684 18.864 15.684 17.499C15.684 16.144 13.634 15.457 9.592 15.457ZM9.592 21.057C7.516 21.057 2 21.057 2 17.519C2 13.957 7.714 13.957 9.592 13.957C12.851 13.957 17.184 14.324 17.184 17.499C17.184 21.057 11.47 21.057 9.592 21.057Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59157 3.5C7.58657 3.5 5.95557 5.131 5.95557 7.135C5.95557 9.139 7.58657 10.77 9.59157 10.77H9.62257C10.5866 10.766 11.4946 10.387 12.1756 9.7C12.8576 9.015 13.2306 8.104 13.2266 7.138C13.2266 5.131 11.5956 3.5 9.59157 3.5ZM9.59157 12.27C6.75957 12.27 4.45557 9.966 4.45557 7.135C4.45557 4.304 6.75957 2 9.59157 2C12.4226 2 14.7266 4.304 14.7266 7.135C14.7326 8.499 14.2036 9.787 13.2396 10.757C12.2776 11.728 10.9926 12.265 9.62557 12.27H9.59157Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4822 11.1318C16.1142 11.1318 15.7932 10.8608 15.7402 10.4858C15.6832 10.0758 15.9682 9.69577 16.3782 9.63877C17.6262 9.46377 18.5682 8.38077 18.5702 7.11877C18.5702 5.86477 17.6722 4.80677 16.4372 4.60477C16.0282 4.53677 15.7512 4.15177 15.8182 3.74277C15.8852 3.33377 16.2722 3.05877 16.6792 3.12377C18.6442 3.44577 20.0702 5.12677 20.0702 7.11977C20.0662 9.12477 18.5692 10.8468 16.5872 11.1248C16.5522 11.1298 16.5172 11.1318 16.4822 11.1318Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_67_1619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 13,
    width: 5,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8452 13.4834H21.979V18.4609H17.8452V13.4834Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_67_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8955 18.4609C19.5925 18.4609 19.3075 18.2759 19.1945 17.9769C19.0475 17.5899 19.2425 17.1559 19.6295 17.0099C20.4795 16.6879 20.4795 16.2949 20.4795 16.1269C20.4795 15.5599 19.8085 15.1719 18.4855 14.9749C18.0755 14.9129 17.7925 14.5309 17.8535 14.1219C17.9155 13.7119 18.3045 13.4369 18.7065 13.4899C21.4125 13.8949 21.9795 15.1479 21.9795 16.1269C21.9795 16.8559 21.6645 17.8429 20.1615 18.4119C20.0745 18.4449 19.9845 18.4609 19.8955 18.4609Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2User);
export default __webpack_public_path__ + "static/media/2User.c03ef1cbd423b5cbd634dbd185fd9ba4.svg";
export { ForwardRef as ReactComponent };